import styled from 'styled-components';



export const PopUpMain = styled.main `
		background: #000000D6;
`;

export const PopUpMainConteiner = styled.main `
	display: flex;
	${'' /* flex-direction: column; */}
	${'' /* flex-wrap: nowrap; */}
	${'' /* align-items: center; */}
	${'' /* justify-content: space-evenly; */}
	width: 100vw;
	height: 100vh;
	top:0;
	flex-wrap: nowrap;

	overflow: scroll;

	position: fixed;
	z-index: 99;
	background: #000000D6;
	.popbg {
		z-index: 90;
		width: 100vw;
		height: 100vh;
		top:0;
		flex-wrap: nowrap;
	}
`;

export const PopUpConteiner = styled.div `
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: space-evenly;

	position: relative;
	${ ''/* width: 90vw; */}
	padding: 3% 3%;
	max-width: 1120px;
	height: fit-content;
	${'' /* max-height: 90vh; */}
	min-height: fit-content;
	margin: auto;

	background: #D5D5D5;
	border-radius: 50px;

	color: #000000;
	text-align: center;

	.certificados-icon {
		margin: 0;
		margin-right: 10px;
	}

	.certificados-icon::before {
		display: flex;
		align-items: center;
		height: 100%;
		${'' /* background: #00ffff63; */}
	}

	.popup-h2 {
		font-family: 'Exo 2';
		font-style: normal;
		font-weight: bold;

		color: #000000;

		/* sem  efeito */
		letter-spacing: 0;
		text-align: center;
	}

	.popup-titulo{
		font-family: 'Exo 2';
		font-style: normal;
		font-weight: bold;
 }

	.popup-texto, .popup-aviso {
		font-family: 'Exo 2';
		font-style: normal;
		font-weight: bold;
		text-align: center;
		font-size: 1.8rem;
		letter-spacing: 0;
		line-height: 40px;

		${'' /* width: 352px; */}
		margin: 10px 0;

		min-height: 58px;
		min-width: 352px;
	}
	.popup-aviso {
		text-align: justify;
	}

	.btn_nav + p {
		margin-top: 15px;
	}
	p + .btn_nav{
		margin-top:0;
	}
	
	.centralizar{
		text-align: center;
	}

	.popup-btn-x {
		font-size: 2.5rem;
	}
	.popup-bloco {
		display: flex;
		flex-direction: column;
		padding: 20px;
		${ ''/* background: aliceblue; */}
		border: 10%;
		border-radius: 3%;
		align-items: center;

		background-image: linear-gradient(180deg, #cac7d5, #dfdbc7);
	}
	.btn_nav {
		width: 30vw;
		min-width: 300px;
	}
	.btn_nav .baixar {
		background-color: #04BF58;
	}
	@media (max-width:700px ) {
		.popup-corpo {
				min-width: auto;
				font-size: 25px;
				padding: 30px 10px;
		}
		.popup-titulo {
				font-size: 30px;
				display: block;
				line-height: 60px;
		}
		.popup-h2 {
				font-family: 'Exo 2';
				font-style: normal;
				font-weight: bold;
				font-size: 20px;
				line-height: 40px;

				color: #000000;
				height: 66px;

				/* sem  efeito */
				letter-spacing: 0;
		}

	}

	@media (min-width:700px) {
		.popup-corpo {
				padding: 70px 10px;
		}
		.popup-h2 {
				font-size: 2.6rem;
				line-height: 40px;
				align-items: center;
		}

		.popup-titulo {
				font-family: 'Exo 2';
				font-style: normal;
				font-weight: bold;
				font-size: 3rem;
				line-height: 40px;

				align-items: center;
				text-align: center;
		}
	}

	ol,ul {
		list-style: inherit;
	}
`;
